import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getAllContractTypes = async ({ companyCode, isTrue=true }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.ContractType}?isAll=true&isTrue=${isTrue}&CompanyCode=${companyCode}`
  );
  return data;
};

const getContractTypeById = async ({ companyCode, code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.ContractType}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

const insertContractType = async (input) => {
  const { data } = await http_payroll.post(Api_EndPoints.ContractType, input);
  return data;
};

const updateContractType = async (input) => {
  const { data } = await http_payroll.put(Api_EndPoints.ContractType, input);
  return data;
};

const deleteContractType = async ({ companyCode, code }) => {
  const { data } = await http_payroll.delete(
    `${Api_EndPoints.ContractType}?CompanyCode=${companyCode}&Code=${code}`
  );
  return data;
};

export const useGetContractTypesQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.ContractType],
    queryFn: () => getAllContractTypes(input),
     refetchOnWindowFocus: false,
    
  });
};

export const useGetContractTypeByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.ContractType],
    queryFn: () => getContractTypeById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertContractTypeMutation = () => {
  return useMutation({
    mutationFn: insertContractType,
  });
};

export const useUpdateContractTypeMutation = () => {
  return useMutation({
    mutationFn: updateContractType,
  });
};

export const useDeleteContractTypeMutation = () => {
  return useMutation({
    mutationFn: deleteContractType,
  });
};
